// extracted by mini-css-extract-plugin
export default {"notice":"NoticeBanner_notice__J5iMs","icon":"NoticeBanner_icon__V+6yO","text":"NoticeBanner_text__NK1Cf"};